import { useQuery } from '@tanstack/react-query'
import { SearchParams } from '@shared/types/searchParams'
import { generateFilters } from '@shared/helpers/generateSearchParams'
import { Exercise, ExerciseProxy } from '@entities/exercise'
import { PaginationResult } from '@shared/types/pagination'

export const useGetExerciseById = (id: number) => {
	const searchFilter = generateFilters({
		property: 'id_exercise',
		value: id,
		operator: 'eq',
		independent: false,
		disableOnEmpty: true,
	})
	const params: SearchParams = {
		limit: 1,
		page: 0,
		start: 0,
		sort: [],
		filter: [searchFilter],
		independent_fields: null,
	}

	return useQuery({
		queryKey: [`exercise_${id}`],
		queryFn: async () => {
			const result: PaginationResult<Exercise> = await ExerciseProxy.search(params)
			if (result.rows.length === 0) {
				throw new Error('Error while getting exercise by id')
			} else {
				return result.rows[0]
			}
		},
		enabled: !!id,
		staleTime: Infinity,
		cacheTime: Infinity,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
		refetchInterval: false,
	})
}
